import { useEffect } from "react";

const CHECKOUT_URL =
  "https://pay.hotmart.com/J103082620D?checkoutMode=10";

const REVEAL_DELAY_MS = 1050 * 1000;

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "vturb-smartplayer": React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & { id?: string };
    }
  }
  interface Window {
    _fbq25: boolean;
    _fbq75: boolean;
  }
}

export default function EspPage() {
  useEffect(() => {
    // Adiciona pixel ESP como pixel secundário
    if ((window as any).fbq) {
      (window as any).fbq('init', '26782883534706315');
      (window as any).fbq('track', 'PageView');
    } else {
      (function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function() { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n;
        n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
        t = b.createElement(e); t.async = true; t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '26782883534706315');
      (window as any).fbq('track', 'PageView');
    }

    // Preloads Vturb
    const preloads = [
      { href: "https://scripts.converteai.net/25f8f442-d0db-4c6b-821d-d030739ac9eb/players/6a053916f6adc3acd7e237c0/v4/player.js", as: "script" },
      { href: "https://scripts.converteai.net/lib/js/smartplayer-wc/v4/smartplayer.js", as: "script" },
      { href: "https://cdn.converteai.net/25f8f442-d0db-4c6b-821d-d030739ac9eb/6a0538f64d614cad1bba72a0/main.m3u8", as: "fetch" },
    ];
    preloads.forEach(({ href, as: asAttr }) => {
      const link = document.createElement("link");
      link.rel = "preload"; link.href = href; link.as = asAttr;
      document.head.appendChild(link);
    });

    // Script do player Vturb
    const s = document.createElement("script");
    s.src = "https://scripts.converteai.net/25f8f442-d0db-4c6b-821d-d030739ac9eb/players/6a053916f6adc3acd7e237c0/v4/player.js";
    s.async = true;
    document.head.appendChild(s);

    // Escuta eventos do Vturb via postMessage
    const handleMessage = (event: MessageEvent) => {
      const data = event.data;
      if (!data || typeof data !== 'object') return;

      // Evento de tempo do Vturb
      const currentTime = data.currentTime ?? data.current_time ?? data.time;
      const duration = data.duration ?? data.total_time;

      if (typeof currentTime === 'number') {
        console.log("Vturb currentTime:", currentTime);

        if (duration && !window._fbq25 && currentTime >= duration * 0.25) {
          window._fbq25 = true;
          (window as any).fbq?.('track', 'ViewContent', { content_name: 'VSL_ESP_25pct' });
          console.log("Pixel: ViewContent 25%");
        }
        if (duration && !window._fbq75 && currentTime >= duration * 0.75) {
          window._fbq75 = true;
          (window as any).fbq?.('track', 'AddToCart', { content_name: 'VSL_ESP_75pct' });
          console.log("Pixel: AddToCart 75%");
        }
        if (currentTime >= 1050) {
          console.log("Reveal ativado via postMessage");
        }
      }
    };

    window.addEventListener('message', handleMessage);

    // Fallback: tenta API nativa do smartplayer após carregar
    const waitForPlayer = setInterval(() => {
      const player = document.querySelector('vturb-smartplayer') as any;
      if (player && typeof player.getCurrentTime === 'function') {
        clearInterval(waitForPlayer);
        console.log("API nativa Vturb encontrada");

        const interval = setInterval(() => {
          const current = player.getCurrentTime?.() ?? 0;
          const total = player.getDuration?.() ?? 0;
          console.log("Vturb API time:", current);

          if (total && !window._fbq25 && current >= total * 0.25) {
            window._fbq25 = true;
            (window as any).fbq?.('track', 'ViewContent', { content_name: 'VSL_ESP_25pct' });
          }
          if (total && !window._fbq75 && current >= total * 0.75) {
            window._fbq75 = true;
            (window as any).fbq?.('track', 'AddToCart', { content_name: 'VSL_ESP_75pct' });
          }
          if (current >= 1050) {
            clearInterval(interval);
          }
        }, 1000);
      }
    }, 2000);

    return () => {
      window.removeEventListener('message', handleMessage);
      clearInterval(waitForPlayer);
    };
  }, []);

  const handleCTA = () => {
    (window as any).fbq('track', 'InitiateCheckout');
    const utmParams = window.location.search;
    window.location.href = CHECKOUT_URL + (utmParams ? "&" + utmParams.slice(1) : "");
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: "#fdf8f3", fontFamily: "'DM Sans', sans-serif", color: "#2a1a14" }}>

      {/* HEADER */}
      <header style={{ width: "100%", background: "#7a2d22", textAlign: "center", padding: "14px 20px" }}>
        <p style={{ fontSize: 13, fontWeight: 500, color: "#fde8d8", letterSpacing: "0.04em", textTransform: "uppercase", margin: 0 }}>
          Método PPS · Rosane Baldissera · Lactancia Sin Dolor
        </p>
      </header>

      {/* HERO */}
      <section style={{ width: "100%", maxWidth: 760, padding: "48px 24px 32px", textAlign: "center" }}>
        <span style={{ display: "inline-block", fontSize: 12, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: "#c2685a", marginBottom: 18 }}>
          Especialista en lactancia materna
        </span>
        <h1 style={{ fontSize: "clamp(28px, 5vw, 46px)", fontWeight: 900, lineHeight: 1.15, color: "#4a2060", marginBottom: 18 }}>
          Amamanta sin dolor y con{" "}
          <span style={{ color: "#c2685a" }}>mucha leche materna</span>{" "}
          desde la primera toma
        </h1>
        <p style={{ fontSize: "clamp(15px, 2vw, 17px)", color: "#7a6458", lineHeight: 1.7, maxWidth: 560, margin: "0 auto 32px" }}>
          Por primera vez, tendrás acceso a técnicas exclusivas de{" "}
          <strong style={{ color: "#2a1a14" }}>Posicionamiento, Agarre y Succión</strong>, reunidas únicamente en el{" "}
          <strong style={{ color: "#2a1a14" }}>Método PPS</strong>, para amamantar sin dolor y con mucha leche materna desde la primera toma de tu bebé.
        </p>
      </section>

      {/* VIDEO */}
      <section style={{ width: "100%", maxWidth: 760, padding: "0 20px 16px" }}>
        <div style={{ position: "relative", width: "100%", background: "#1a0a08", borderRadius: 16, overflow: "hidden", boxShadow: "0 20px 60px rgba(122,45,34,0.25)" }}>
          <vturb-smartplayer id="vid-6a053916f6adc3acd7e237c0" style={{ display: "block", width: "100%", margin: "0 auto" }} />
        </div>
      </section>

      {/* REVEAL */}
      <section id="reveal-section" style={{ 
        width: "100%", 
        maxWidth: 760, 
        padding: "0 20px",
        display: "none"
      }}>

        {/* CTA PRINCIPAL */}
        <div style={{ margin: "36px 0", textAlign: "center" }}>
          <p style={{ fontSize: 12, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#7a6458", marginBottom: 14 }}>
            ¡Precio de lanzamiento por tiempo limitado!
          </p>
          <button onClick={handleCTA} style={{ display: "inline-block", background: "linear-gradient(135deg, #d4724e, #c2685a)", color: "#fff", fontSize: 17, fontWeight: 700, padding: "18px 42px", borderRadius: 100, border: "none", cursor: "pointer", boxShadow: "0 8px 32px rgba(194,104,90,0.45)", letterSpacing: "0.01em" }}>
            Quiero amamantar sin dolor →
          </button>
          <p style={{ marginTop: 12, fontSize: 13, color: "#7a6458" }}>
            <span style={{ color: "#c8922a", fontWeight: 600 }}>15 días de garantía</span> · Acceso inmediato · Pago 100% seguro
          </p>
        </div>

        {/* GARANTIA */}
        <div style={{ display: "flex", alignItems: "center", gap: 18, background: "#f5ede0", border: "1.5px solid #e8c4b8", borderRadius: 14, padding: "20px 24px", marginBottom: 36 }}>
          <div style={{ flexShrink: 0, width: 72, height: 72, borderRadius: "50%", background: "linear-gradient(135deg, #c8922a, #e8b84b)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#fff" }}>
            <span style={{ fontSize: 24, fontWeight: 900, lineHeight: 1 }}>15</span>
            <span style={{ fontSize: 8, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", textAlign: "center" }}>días de garantía</span>
          </div>
          <div>
            <h4 style={{ fontSize: 15, fontWeight: 700, marginBottom: 4 }}>Satisfacción garantizada o te devolvemos el dinero</h4>
            <p style={{ fontSize: 13, color: "#7a6458", lineHeight: 1.6 }}>Si dentro de los primeros 15 días no ves resultados, te devolvemos el 100% de tu inversión. Sin preguntas, sin burocracia.</p>
          </div>
        </div>

        {/* TESTIMONIOS */}
        <h2 style={{ fontSize: 22, fontWeight: 700, color: "#4a2060", textAlign: "center", marginBottom: 24 }}>Lo que dicen las mamás</h2>

        {[
          { name: "Joana S. Moura", text: "\"Después de pasar por 2 consultoras de lactancia y 2 pediatras que no pudieron ayudarme, gracias a este Método, logré salvar la lactancia de mi bebé. Hoy estamos en lactancia exclusiva, él ganando aproximadamente 42g por día, ¡y finalmente rompimos el ciclo del dolor!\"" },
          { name: "Editiane De Alcantara Petruzzellis", text: "\"Aquí también salvó la lactancia de Valentina 💕, fue mi mejor inversión. Ahorré en fórmulas caras y además protegí a mi hija con anticuerpos. Es mi tercer hijo, los dos primeros no mamaron, pensé que nunca lo lograría, y estoy aquí a 1 año y 3 meses firme y fuerte. ¡Muchas gracias!\"" },
        ].map((t, i) => (
          <div key={i} style={{ background: "#fff", border: "1px solid #ede4da", borderRadius: 14, padding: "22px 24px", marginBottom: 16, boxShadow: "0 2px 12px rgba(122,45,34,0.07)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
              <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#e8c4b8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>🤱</div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{t.name}</div>
                <div style={{ color: "#c8922a", fontSize: 13 }}>★★★★★</div>
              </div>
            </div>
            <p style={{ fontSize: 14, lineHeight: 1.75, color: "#4a3a34" }}>{t.text}</p>
          </div>
        ))}

        {/* SEGUNDO CTA */}
        <div style={{ margin: "36px 0 60px", textAlign: "center" }}>
          <button onClick={handleCTA} style={{ display: "inline-block", background: "linear-gradient(135deg, #d4724e, #c2685a)", color: "#fff", fontSize: 17, fontWeight: 700, padding: "18px 42px", borderRadius: 100, border: "none", cursor: "pointer", boxShadow: "0 8px 32px rgba(194,104,90,0.45)" }}>
            Quiero amamantar sin dolor →
          </button>
          <p style={{ marginTop: 12, fontSize: 13, color: "#7a6458" }}>
            <span style={{ color: "#c8922a", fontWeight: 600 }}>¡Aprovecha el precio de lanzamiento!</span>
          </p>
        </div>

      </section>

      {/* FOOTER */}
      <footer style={{ width: "100%", background: "#7a2d22", padding: 20, textAlign: "center" }}>
        <p style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", lineHeight: 1.7, margin: 0 }}>
          © {new Date().getFullYear()} Rosane Baldissera · Método PPS · Todos los derechos reservados
        </p>
      </footer>

    </div>
  );
}
